import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { Container } from '../Container';
import { ProductsSliderContentType } from '../contentTypes';
import { Section } from '../Section';
import { SliderProduct } from '../slider/SliderProduct';

export interface ProductsSliderProps extends ProductsSliderContentType {}

export const ProductsSlider = ({ footer, header, products }: ProductsSliderProps) => {
  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <Section className="products-slider text-white">
      {(header?.title || header?.subtitle) && (
        <Container>
          <b2x.Row>
            <b2x.Col>
              <div className="mt-lg-5 text-center">
                {header.title && (
                  <h3
                    className={classnames(
                      'fw-bold mb-2',
                      { h1: !b2x.untilBreakpoint('md', currentBreakpoint) },
                      { h3: b2x.untilBreakpoint('md', currentBreakpoint) },
                    )}
                  >
                    {b2x.formatHtml(header.title)}
                  </h3>
                )}
                {header.subtitle && (
                  <p className={classnames('m-0', { h2: !b2x.untilBreakpoint('md', currentBreakpoint) })}>
                    {b2x.formatHtml(header.subtitle)}
                  </p>
                )}
              </div>
            </b2x.Col>
          </b2x.Row>
        </Container>
      )}
      {products && products.length > 0 && (
        <div className="py-3 py-lg-5 text-center">
          <Container>
            <b2x.ProductsByIds ids={products.map(({ product }) => product)}>
              {(_products) =>
                _products && (
                  <b2x.Listing name="Page builder - Products Slider" products={_products}>
                    <SliderProduct products={_products} />
                  </b2x.Listing>
                )
              }
            </b2x.ProductsByIds>
          </Container>
        </div>
      )}
      {(footer?.title || footer?.cta?.label) && (
        <Container>
          <b2x.Row className="justify-content-center">
            <b2x.Col size={{ lg: 10, xs: 12 }}>
              <div className="mb-lg-5 pt-3 pt-lg-5 border-top  text-center">
                {footer.title && (
                  <h3
                    className={classnames(
                      'fw-bold mb-3 mb-lg-5',
                      { h1: !b2x.untilBreakpoint('md', currentBreakpoint) },
                      { h3: b2x.untilBreakpoint('md', currentBreakpoint) },
                    )}
                  >
                    {b2x.formatHtml(footer.title)}
                  </h3>
                )}
                {footer.cta && (
                  <div className="d-grid d-sm-block">
                    <b2x.CtaFromContent
                      ctaProps={{ button: { className: 'fw-medium text-uppercase', variant: 'outline-secondary' } }}
                      {...footer.cta}
                    />
                  </div>
                )}
              </div>
            </b2x.Col>
          </b2x.Row>
        </Container>
      )}
    </Section>
  );
};
